import { NgModule } from "@angular/core";
import { FileserverApiService } from "./services/fileserver-api.service";
import { FileserverFacade } from "./services/fileserver-facade.service";
import { FileserverState } from "./services/fileserver-state.service";

@NgModule({
  providers: [FileserverState, FileserverApiService, FileserverFacade],
})
export class FileserverModule {}
